import type { Currency } from "@core/schema/Currency.js";

export const selectedCurrency = $state<{ current: Currency | null }>({ current: null });
